window.enableHoverVideoForCard = function(card) {
  const video = card.querySelector(".product-card__video");

  if (video) {
    card.addEventListener("mouseenter", function() {
      video.play();
    });

    card.addEventListener("mouseleave", function() {
      video.pause();
      video.currentTime = 0;
    });
  }
};


function initializeSidebarMenu() {
  document.querySelectorAll('.header-sidebar__linklist-button').forEach(button => {
    button.addEventListener('click', function() {
      const panelId = button.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);

      if (panel) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.hidden = isExpanded;
        panel.classList.toggle('is-open', !isExpanded);
      }
    });
  });
}

function initializeBackButton() {
  document.querySelectorAll('.header-sidebar__back-button-child').forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      const parentPanel = button.closest('.header-sidebar__sub-panel-child');
      
      if (parentPanel) {
        parentPanel.setAttribute('hidden', 'true');
        parentPanel.classList.remove('is-open');

        const parentPanelId = parentPanel.id;
        const linkButton = document.querySelector(`.header-sidebar__linklist-button[aria-controls="${parentPanelId}"]`);
        
        if (linkButton) {
          linkButton.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });
}

function checkMenuWrap() {
  const nav = document.querySelector('nav.header__primary-nav');
  if (!nav) return;

  const items = nav.querySelectorAll('.header__primary-nav-item');
  const  secondaryItems = document.querySelector('nav.header__secondary-nav');
  const header = nav.closest('.header');

  if (secondaryItems) {
    secondaryItems.style.opacity = '1';
  }

  if(nav){
    nav.style.opacity = '1';
  }
  
  if (!header || items.length === 0) return;

  const firstTop = items[0].offsetTop;
  let hasWrap = false;

  for (let i = 1; i < items.length; i++) {
    if (items[i].offsetTop > firstTop) {
      hasWrap = true;
      break;
    }
  }

  if (hasWrap && !header.classList.contains('has-wrap')) {
    header.classList.add('has-wrap');
  } else if (!hasWrap && header.classList.contains('has-wrap')) {
    header.classList.remove('has-wrap');
  }
}

window.addEventListener('resize', checkMenuWrap);

document.addEventListener("DOMContentLoaded", function() {
  checkMenuWrap();
  initializeSidebarMenu();
  initializeBackButton();
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-swiper').forEach(function(swiperEl) {
    var pid = swiperEl.id.replace('product-swiper-', '');
    var prevBtnSelector = '.swiper-button-prev-' + pid;
    var nextBtnSelector = '.swiper-button-next-' + pid;
    var paginationSelector = '.swiper-pagination-' + pid;

    var swiper = new Swiper('#' + swiperEl.id, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: nextBtnSelector,
        prevEl: prevBtnSelector,
      },
      pagination: {
        el: paginationSelector,
        clickable: true,
      },
      preloadImages: false,
      lazy: true,
    });
  });

  document.querySelectorAll('collection-layout-switch').forEach(switchEl => {
    const activeBtn = switchEl.querySelector('button[type="button"].is-active');
    if (activeBtn) {
      const value = activeBtn.value;
      document.querySelectorAll('.product-swiper.only-mobile').forEach(swiperEl => {
        const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!swiperWrapper) return;
        const slides = Array.from(swiperWrapper.children);
        let targetSlide = null;
        slides.forEach(slide => {
          const img = slide.querySelector('img[data-view]');
          if (img && img.getAttribute('data-view') === value) {
            targetSlide = slide;
          }
        });
        if (!targetSlide) return;
        if (slides[0] !== targetSlide) {
          swiperWrapper.insertBefore(targetSlide, slides[0]);
        }
      });
    }
  });

  document.querySelectorAll('collection-layout-switch').forEach(switchEl => {
    switchEl.querySelectorAll('button[type="button"]').forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.value;
        document.querySelectorAll('.product-swiper.only-mobile').forEach(swiperEl => {
          const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
          if (!swiperWrapper) return;
          const slides = Array.from(swiperWrapper.children);
          let targetSlide = null;
          slides.forEach(slide => {
            const img = slide.querySelector('img[data-view]');
            if (img && img.getAttribute('data-view') === value) {
              targetSlide = slide;
            }
          });
          if (!targetSlide) return;
          if (slides[0] !== targetSlide) {
            swiperWrapper.insertBefore(targetSlide, slides[0]);
          }
        });
      });
    });
  });
});


(function patchVariantPicker() {
  const LOADING_STYLE = `
    pointer-events: none !important;
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  `;

  const dopatch = () => {
    const VP = customElements.get('variant-picker');
    if (!VP || VP.prototype.__lockPatchApplied) return;
    VP.prototype.__lockPatchApplied = true;

    const original = VP.prototype.selectCombination;

    VP.prototype.selectCombination = async function(args) {
      const formId = this.getAttribute('form-id');

      const inputs = document.querySelectorAll(
        `input[data-option-position][form="${formId}"], label[for]`
      );

      const addToCartBtns = document.querySelectorAll(
        `button[type="submit"][form="${formId}"],
         form#${formId} button[type="submit"],
         .shopify-payment-button__button`
      );

      inputs.forEach(el => el.setAttribute('style', LOADING_STYLE));
      addToCartBtns.forEach(el => {
        el.setAttribute('disabled', 'disabled');
        el.setAttribute('style', LOADING_STYLE);
      });
      this.setAttribute('style', LOADING_STYLE);

      try {
        await original.call(this, args);
      } finally {
        inputs.forEach(el => el.removeAttribute('style'));
        addToCartBtns.forEach(el => {
          el.removeAttribute('disabled');
          el.removeAttribute('style');
        });
        this.removeAttribute('style');
      }
    };
  };

  if (customElements.get('variant-picker')) {
    dopatch();
  } else {
    customElements.whenDefined('variant-picker').then(dopatch);
  }
})();
